export default __webpack_public_path__ + "static/media/au.f11a6ea7.png";